import { useDroppable } from '@dnd-kit/core';
import parse, {
  attributesToProps,
  type DOMNode,
  domToReact,
  Element,
  type HTMLReactParserOptions,
} from 'html-react-parser';
import { Link, useOutletContext } from 'react-router';

function DrugDetails() {
  const { content } = useOutletContext<{ content: string }>();
  const { setNodeRef } = useDroppable({
    id: '1',
  });

  const options: HTMLReactParserOptions = {
    replace(domNode) {
      if (domNode instanceof Element && domNode.attribs) {
        if (domNode.name === 'span' && domNode.attribs.target === '_parent') {
          const props = attributesToProps(domNode.attribs);
          return (
            <Link {...props} target={undefined} to={props.href as string}>
              {domToReact(domNode.children as DOMNode[])}
            </Link>
          );
        }
        if (domNode.name === 'span' && domNode.attribs.target === '_blank') {
          const props = attributesToProps(domNode.attribs);
          return (
            <a {...props} href={props.href as string} target="_blank">
              {domToReact(domNode.children as DOMNode[])}
            </a>
          );
        }
      }
    },
  };

  return (
    <div ref={setNodeRef}>
      <div
        className="prose text-foreground prose-p:mb-1.5 prose-p:mt-0 prose-li:my-0 prose-ul:ml-6 prose-ul:mt-0 prose-ul:mb-5 prose-ul:list-disc prose-ul:[&>ul]:[&>li]:list-[circle] marker:text-foreground max-w-screen-xl"
        id="search-node">
        {parse(content, options)}
      </div>
    </div>
  );
}

export default DrugDetails;
